import { Field } from 'formik';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../types/fields';
import getValidator from '../../utils/getValidator';
import TextField from '../formik/TextField';

const FirstNameField = (props: FieldProps) => {
  const { formatMessage } = useIntl();

  return (
    <Field
      name={[props.context, 'firstName'].filter(Boolean).join('.')}
      component={TextField}
      label={formatMessage({ id: 'generic.firstName' })}
      maxLength={50}
      validate={getValidator({ required: true, minLength: 1, format: 'name' })}
      data-test-id={`${props.testIdPrefix}-firstName`}
    />
  );
};

export default FirstNameField;
